import React from 'react';
import styles from './Gallery.module.css';

const Gallery = ({ images }) => {
  return (
    <div className={styles.container}>
      {images.map((image, i) => (
        <div key={'img-container-' + i} className={styles.imageContainer}>
          <a
            key={'anchor-' + i}
            href={image.img}
            target="_blank"
            rel="noreferrer"
          >
            <img
              key={'image-' + i}
              src={image.img}
              alt=""
              className={styles.image}
            />
          </a>
        </div>
      ))}
    </div>
  );
};

export default Gallery;
